var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbstract5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 381,
    viewBox: "0 0 210 381",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.849 308.119C102.306 356.566 36.8876 362.604 -27.8111 364.125L-35.0217 369.525C-36.6186 372.714 -42.9976 381.752 -35.222 380.726C-19.2959 378.625 -2.9838 381.069 13.0487 379.126C28.034 377.31 43.8947 375.597 58.7157 372.725C97.1962 365.269 133.931 346.701 159.463 316.72C178.25 294.661 195.575 270.435 201.024 241.413C207.232 208.35 214.923 170.032 205.431 137.104C197.552 109.775 184.121 86.7214 163.669 66.2975C143.217 45.8729 106.855 38.7817 80.1471 28.9941C49.7101 17.8399 16.9885 3.98715 -15.393 0.291504C-27.2134 -1.05753 -28.1121 2.17648 -27.8111 12.0926C-27.5691 20.0706 -9.78319 19.1322 -3.77592 20.2933C37.3009 28.2327 79.7084 35.5454 117.001 55.6966C137.301 66.6657 159.178 78.9405 170.88 99.7005C180.809 117.316 184.53 136.607 189.207 156.006C201.061 205.18 185.886 271.398 149.849 308.119Z",
    fill: "#D6C2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstract5);
export default __webpack_public_path__ + "static/media/abstract-5.807642700500e821865c41210f57183d.svg";
export { ForwardRef as ReactComponent };